import { z } from 'zod'
import { channelSourceData } from './channelSource'
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'

extendZodWithOpenApi(z)

export enum AchCodes {
    TwentyPercent = 'D20P6M',
    FiftyPercent = 'D50P6M',
}

export type AchCodesType = `${AchCodes}`

export const InitCheckoutRequestSchema = z
    .object({
        transactionId: z.string().uuid().optional(),
        channelSourceData: channelSourceData
            .pick({
                checkoutSourceRef: true,
            })
            .required({
                checkoutSourceRef: true,
            }),
    })
    .openapi('InitCheckoutRequestSchema')

export const InitCheckoutApplianceResponseSchema = z.object({
    itemIterationId: z.string(),
    achDiscountedSalesTaxRate: z
        .number()
        .describe(
            'The ACH discounted sales tax rate, the returned number is in decimal up to 2 decimal places',
        ),
    achDiscountedNetAmount: z
        .number()
        .describe(
            'The ACH discounted net amount, the returned number is in decimal up to 2 decimal places',
        ),
    achDiscountedSalesTaxAmount: z
        .number()
        .describe(
            'The ACH discounted sales tax amount, the returned number is in decimal up to 2 decimal places',
        ),
    salesTaxRate: z
        .number()
        .describe(
            'The sales tax rate, the returned number is in decimal up to 2 decimal places',
        ),
    netAmount: z
        .number()
        .describe(
            'The net amount, the returned number is in decimal up to 2 decimal places',
        ),
    salesTaxAmount: z
        .number()
        .describe(
            'The sales tax amount, the returned number is in decimal up to 2 decimal places',
        ),
})

export const InitCheckoutResponseSchema = z
    .object({
        credentials: z.object({
            paysafeIframeToken: z.string(), // base64 string to authenticate against paysafe
            paysafeAccountNumber: z.number(),
        }),
    })
    .openapi('InitCheckoutResponseSchema')

// Types
export type InitCheckoutPayload = z.infer<typeof InitCheckoutRequestSchema>
export type InitCheckoutResponse = z.infer<typeof InitCheckoutResponseSchema>
export type InitCheckoutApplianceResponse = z.infer<
    typeof InitCheckoutApplianceResponseSchema
>
